import { useRef, useEffect } from "react";

var canUsePassiveEvents = function canUsePassiveEvents() {
  if ("undefined" == typeof window || "function" != typeof window.addEventListener) return !1;

  var e = !1,
      n = Object.defineProperty({}, "passive", {
    get: function get() {
      e = !0;
    }
  }),
      t = function t() {
    return null;
  };

  return window.addEventListener("test", t, n), window.removeEventListener("test", t, n), e;
},
    DEFAULT_IGNORE_CLASS = "ignore-onclickoutside",
    hasIgnoreClass = function hasIgnoreClass(e, n) {
  for (var t = e.target; t;) {
    if (t.classList.contains(n)) return !0;
    t = t.parentElement;
  }

  return !1;
},
    clickedOnScrollbar = function clickedOnScrollbar(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
},
    getEventOptions = function getEventOptions(e) {
  return !(!e.includes("touch") || !canUsePassiveEvents()) && {
    passive: !0
  };
},
    useOnclickOutside = function useOnclickOutside(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      i = t.disabled,
      r = void 0 !== i && i,
      o = t.eventTypes,
      c = void 0 === o ? ["mousedown", "touchstart"] : o,
      u = t.excludeScrollbar,
      s = void 0 !== u && u,
      f = t.ignoreClass,
      a = void 0 === f ? DEFAULT_IGNORE_CLASS : f,
      d = useRef(n);
  useEffect(function () {
    d.current = n;
  }, [n]), useEffect(function () {
    if (e) {
      var n = function n(_n) {
        if (!hasIgnoreClass(_n, a)) {
          var t = Array.isArray(e) ? e : [e],
              i = [];
          t.forEach(function (e) {
            var n = e.current;
            n && i.push(n);
          }), s && clickedOnScrollbar(_n) || i.length && i.every(function (e) {
            return !e.contains(_n.target);
          }) && d.current(_n);
        }
      },
          t = function t() {
        c.forEach(function (e) {
          document.removeEventListener(e, n, getEventOptions(e));
        });
      };

      if (!r) return c.forEach(function (e) {
        document.addEventListener(e, n, getEventOptions(e));
      }), function () {
        t();
      };
      t();
    }
  }, [e, a, s, r, c]);
};

export default useOnclickOutside;
export { DEFAULT_IGNORE_CLASS };